import "rsuite/dist/rsuite.min.css";
import "./app.scss";
import DetailPage from "./components/DetailPage/DetailPage.js";
import Navbar from "./components/landing/header/Navbar.js";
import Landing from "./components/landing/Landing.js";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Privatepoll from "./components/Privatepoll/Privatepoll.js";
import Mycreatedpolls from "./components/Mycreatedpolls/Mycreatedpolls.js";
import Createpool from "./components/Createprivatepoll/Createpool.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MyPrediction from "./components/Mycreatedpolls/MyPrediction.js";
import PointsBreakdown from "./components/Mycreatedpolls/PointsBreakdown.js";
import Blog from "./components/Blog/Blog.js";
import BlogDetail from "./components/Blog/BlogDetail.js";
import Homepage from "./components/Homepage/Homepage.js";
import { useState } from "react";
import GetRain from "./components/GetRain/GetRain.js";
import Termsofuse from "./components/Termsofuse/Termsofuse.js";
import Privacy from "./components/Termsofuse/Privacy.js";
import About from "./components/AboutUs/About.js";
import BrandAssets from "./components/BrandAssets/BrandAssets.js";
import UserProfile from "./components/Mycreatedpolls/UserProfile.js";
import Liquidity from "./components/RiskMarket/Liquidity.js";
import NotFound from "./components/NotFound/NotFound.js";
import Apps from "./components/Apps/Apps.js";
import Builders from "./components/Builders/Builders.js";
import Raindetailpage from "./components/Apps/Raindetailpage/Raindetailpage.js";
import NavbarHome from "./components/Homepage/Navbar/Navbar.js";
import BreadcrumbSchema from "./components/BreadcrumbSchema.js";
import GenerateMarkets from "./components/GenerateMarkets/index.jsx";
import { ROUTES } from "./constants/Routes.js";
import { SHOW_GENERATE_MARKETS } from "./utils/Enviroment.js";

const homeNavbarRoutes = [
  ROUTES.HOME,
  ROUTES.APPS,
  ROUTES.BUILDERS,
  ROUTES.APP_DETAIL,
  ROUTES.GET_RAIN,
  ROUTES.ABOUT,
  ROUTES.BRAND_ASSETS,
  ROUTES.LIQUIDITY,
];

function AppLayout({ show6, setShow6 }) {
  const location = useLocation();

  const isHomeNavbar =
    homeNavbarRoutes.includes(location.pathname) ||
    location.pathname.startsWith(`${ROUTES.APPS}/`);

  return (
    <>
      <BreadcrumbSchema />
      {isHomeNavbar ? (
        <NavbarHome />
      ) : (
        <Navbar show6={show6} setShow6={setShow6} />
      )}

      <Routes>
        <Route path={ROUTES.PRED} element={<Landing />} />
        <Route path={ROUTES.DETAIL} element={<DetailPage />} />
        <Route path={ROUTES.MYCREATEDPOLLS} element={<Mycreatedpolls />} />
        <Route path={ROUTES.MYPREDICTION} element={<MyPrediction />} />
        <Route path={ROUTES.POINTS_BREAKDOWN} element={<PointsBreakdown />} />
        <Route path={ROUTES.CREATEPOOL} element={<Createpool />} />
        <Route
          path={ROUTES.HOME}
          element={<Homepage show6={show6} setShow6={setShow6} />}
        />
        <Route path={ROUTES.OLD_DETAIL} element={<Navigate to={ROUTES.DETAIL} replace />} />
        <Route path={ROUTES.OLD_MYCREATEDPOLLS} element={<Navigate to={ROUTES.MYCREATEDPOLLS} replace />} />
        <Route path={ROUTES.OLD_MYPREDICTION} element={<Navigate to={ROUTES.MYPREDICTION} replace />} />
        <Route path={ROUTES.OLD_POINTS_BREAKDOWN} element={<Navigate to={ROUTES.POINTS_BREAKDOWN} replace />} />
        <Route path={ROUTES.OLD_CREATEPOOL} element={<Navigate to={ROUTES.CREATEPOOL} replace />} />
        <Route path={ROUTES.PRIVATEMARKET} element={<Privatepoll />} />
        <Route path={ROUTES.BLOG} element={<Blog />} />
        <Route path={ROUTES.BLOG_DETAIL} element={<BlogDetail />} />
        <Route path={ROUTES.GET_RAIN} element={<GetRain />} />
        <Route path={ROUTES.TERMS} element={<Termsofuse />} />
        <Route path={ROUTES.PRIVACY} element={<Privacy />} />
        <Route path={ROUTES.ABOUT} element={<About />} />
        <Route path={ROUTES.BRAND_ASSETS} element={<BrandAssets />} />
        <Route path={ROUTES.USER_PROFILE} element={<UserProfile />} />
        <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
        <Route path={ROUTES.APPS} element={<Apps />} />
        <Route path={ROUTES.BUILDERS} element={<Builders />} />
        <Route path={ROUTES.APP_DETAIL} element={<Raindetailpage />} />
        <Route path={ROUTES.LIQUIDITY} element={<Liquidity />} />
        {SHOW_GENERATE_MARKETS && (
          <Route path={ROUTES.GENERATEMARKET} element={<GenerateMarkets />} />
        )}
        <Route path="*" element={<Navigate to={ROUTES.NOT_FOUND} />} />
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        style={{ fontSize: "16px", zIndex: "9999999999999999" }}
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
}

function App() {
  const [show6, setShow6] = useState(false);
  return (
    <Router>
      <AppLayout show6={show6} setShow6={setShow6} />
    </Router>
  );
}

export default App;
